import { defineComponent as _defineComponent } from 'vue';
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "pre-order"
};
const _hoisted_2 = { class: "pre-order__wrap" };
const _hoisted_3 = { class: "pre-order__na" };
const _hoisted_4 = { class: "pre-order__text" };
const _hoisted_5 = { class: "pre-order__button" };
const _hoisted_6 = ["data-id", "data-type"];
import Message from "../../../components/Message.vue";
export default /*@__PURE__*/ _defineComponent({
    __name: 'PreOrder',
    props: {
        available: { type: Boolean },
        type: { type: Object },
        productId: { type: Number, required: true },
    },
    setup(__props) {
        return (_ctx, _cache) => {
            return (!__props.available || __props.type?.disabled)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("div", _hoisted_3, [
                            _createVNode(Message, {
                                strong: "",
                                icon: "cart-cross"
                            }, {
                                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                                        _createTextVNode("Товара нет в наличии", -1 /* CACHED */)
                                    ]))]),
                                _: 1 /* STABLE */
                            })
                        ]),
                        _cache[2] || (_cache[2] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_4, "Вы можете оформить предзаказ и мы свяжемся с вами,\n        когда " + _toDisplayString(__props.type?.name?.toLocaleLowerCase('ru') ?? 'товар') + " появится в наличии\n      ", 1 /* TEXT */),
                        _cache[3] || (_cache[3] = _createTextVNode()),
                        _createElementVNode("div", _hoisted_5, [
                            _createElementVNode("button", {
                                type: "button",
                                class: "btn btn--1 btn--l btn--black win",
                                "data-act": "preorder",
                                "data-id": __props.productId,
                                "data-type": __props.type?.id
                            }, [...(_cache[1] || (_cache[1] = [
                                    _createElementVNode("span", { class: "btn__label" }, "Предзаказ", -1 /* CACHED */)
                                ]))], 8 /* PROPS */, _hoisted_6)
                        ])
                    ])
                ]))
                : _createCommentVNode("v-if", true);
        };
    }
});
